module.exports = __webpack_public_path__ + "img/users_icon.fffe0180.svg";